import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import styles from './VideoMeetingsScreen.module.css';

const GroupMeeting = ({ setMode, handleStartGroupMeeting }) => {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div className={styles.container}>
        <div className={styles.card}>
          <button className={styles.backButton} onClick={() => setMode(null)}>
            {t('screens.video.meetings.back')}
          </button>

          <div className={styles.header}>
            <h1 className={styles.title}>{t('screens.video.meetings.groupMeetingTitle')}</h1>
            <p className={styles.subtitle}>{t('screens.video.meetings.startInvite')}</p>
          </div>

          <div className={styles.confirmBox}>
            <p>{t('screens.video.meetings.confirmStart')}</p>
          </div>

          <div className={styles.actions}>
            <button className={styles.cancelButton} onClick={() => setMode(null)}>
              {t('screens.video.meetings.cancel')}
            </button>
            <button className={styles.callButton} onClick={handleStartGroupMeeting}>
              {t('screens.video.meetings.startMeeting')}
            </button>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default GroupMeeting;
